import { logisticsApi } from "@/api/ApiClient";
import { useQuery } from "@tanstack/react-query";
import { employee, employees } from "@medoma/models/shifts";
import { useUserProfile } from "./Users";

const fetchEmployee = async (employeeNumber: number) => {
  const parsedEmployee = await logisticsApi
    .get(`/ambulating/employees/${employeeNumber}`)
    .json(employee);
  return parsedEmployee;
};

async function fetchEmployees() {
  const parsedEmployees = await logisticsApi
    .get("/ambulating/employees")
    .json(employees);
  return parsedEmployees.sort((a, b) => a.firstName.localeCompare(b.firstName));
}

const employeeKeys = {
  all: ["employees"] as const,
  lists: () => [...employeeKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) =>
    [...employeeKeys.lists(), { filters }] as const,
  detail: (id: number) => [...employeeKeys.all, id, "details"] as const,
};

const employeeQueryOptions = (employeeNumber: number) => ({
  queryKey: employeeKeys.detail(employeeNumber),
  queryFn: () => fetchEmployee(employeeNumber),
});

export const useCurrentEmployee = () => {
  const { employeeNumber } = useUserProfile();
  const employeeNumberAsNumber = Number(employeeNumber);
  return useQuery({
    queryKey: employeeKeys.detail(employeeNumberAsNumber),
    queryFn: () => fetchEmployee(employeeNumberAsNumber),
    enabled: Boolean(employeeNumber),
  });
};

export const useEmployee = ({ employeeNumber }: { employeeNumber: number }) => {
  return useQuery(employeeQueryOptions(employeeNumber));
};

export const useEmployees = () => {
  return useQuery({
    queryKey: employeeKeys.lists(),
    queryFn: fetchEmployees,
  });
};
